import {EntityData, field, identifier} from "@fedeltapointofsale/data-client";

export class ProductContainerData extends EntityData<ProductContainerData> {
    @identifier containerId: string;
    @field name: string;
    @field weight: number = 0.00;
    @field description: string;
}
